export default __webpack_public_path__ + "static/media/cabinet1-after-2048w.a8c7827e.avif";